import React, {useState, useEffect} from 'react';


import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from '@material-ui/core/Paper';
import List from "@material-ui/core/List";

import {useGetUserGroups} from "shared-react/api/UserGroupApi";
import {
    getUserGroupPath,
    getUserGroupsPath,
    ROUTE_USER_GROUPS_NEW,
} from 'shared-react/utils/routes';
import PageTitleWithButton from "utils/PageTitleWithButton";
import LinkWrapper from "utils/LinkWrapper";
import ListTablePagination from "utils/ListTablePagination";
import DataLoadingIndicator from "shared-react/utils/DataLoadingIndicator";

function UserGroupsPage({match, history}) {
    const page = typeof match.params.page === 'undefined' ? 1 : match.params.page;
    const perPage = 20;
    const queryParams = {
        page,
        perPage,
    };
    const [userGroups, totalCount, isUserGroupsLoading, userGroupsErrors, fetchUserGroups] = useGetUserGroups(queryParams);

    useEffect(() => {
        fetchUserGroups();
    }, [page]);


    if (!userGroups) {
        return (<DataLoadingIndicator />);
    }

    return (
        <React.Fragment>
            <PageTitleWithButton
                pageTitle={"Klientų grupės"}
                buttonTitle={"Pridėti naują"}
                buttonRoute={ROUTE_USER_GROUPS_NEW}
                gutterBottom
            />
            <Paper>
                <List dense={true}>
                    {userGroups.map((userGroup) =>
                        <ListItem
                            key={userGroup.id}
                            button
                            to={getUserGroupPath(userGroup.id)}
                            component={LinkWrapper}
                        >
                            <ListItemText
                                primary={userGroup.title}
                            />
                        </ListItem>
                    )}
                </List>
                <ListTablePagination
                    perPage={perPage}
                    totalCount={totalCount}
                    page={page}
                    onChangePage={(event, page) => {
                        history.push(getUserGroupsPath(page));
                    }}
                />
            </Paper>
        </React.Fragment>
    );
}

export default UserGroupsPage;